import { render, staticRenderFns } from "./AttendanceChatMessage.vue?vue&type=template&id=ca3071aa"
import script from "./AttendanceChatMessage.vue?vue&type=script&lang=js"
export * from "./AttendanceChatMessage.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatMessage.vue?vue&type=style&index=0&id=ca3071aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QIcon});
